import {axiosGetHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

// 不显示对应广告
export function getReadIndexTask(args) {
  let url = BASE_API + '/chatroom/v2/task/index_task/read'
  return axiosGetHandler(url, args)
}

// 获取广告
export function getIndexTask(args) {
  let url = BASE_API + '/chatroom/v2/task/index_task'
  return axiosGetHandler(url, args)
}